// Copyright (c) 2024 Deere & Company

/* eslint-disable complexity, max-params */

export const buildPayload = (selectedAccounts, exportToExcel = '', language = '', listId = '', layoutName = '') => ({
    accounts: selectedAccounts,
    export: exportToExcel,
    language,
    layout: layoutName,
    listId
});

/* eslint-enable complexity, max-params */



// WEBPACK FOOTER //
// ./src/tcsm/wip/services/amount-of-use-request-build-payload.js